import NoPrint from "components/NoPrint";
import Stack from "components/Stack";

import MemoCommentsContextButton from "entities/Memo/components/Comments/ContextButton";
import NoProformaUploaded from "entities/Memo/components/Sections/NoProformaUploaded";
import SectionSummary from "entities/Memo/components/Sections/Summary";
import { IMemoSection } from "entities/Memo/sdk";
import { useProformaForDealManager } from "entities/Memo/utils";
import ProformaDevelopmentBudget from "entities/Proforma/components/ProformaDevelopmentBudget";

interface ISectionDevelopmentBudget {
  dealId: number;
  externalToken?: string;
  section?: IMemoSection;
  onUpdate?: () => void;
}

const SectionDevelopmentBudget: React.FC<ISectionDevelopmentBudget> = ({
  dealId,
  externalToken,
  section,
  onUpdate,
}) => {
  const { data: proforma } = useProformaForDealManager({
    dealId,
    token: externalToken,
  });

  return (
    <>
      {proforma ? (
        <Stack spacing={2}>
          {section && !externalToken && (
            <NoPrint
              sx={{
                display: "inline-block",
                marginLeft: "10px",
                lineHeight: "24px",
                alignSelf: "flex-end",
              }}
            >
              <MemoCommentsContextButton
                dealId={dealId}
                section={section}
                onClose={onUpdate}
              />
            </NoPrint>
          )}
          <Stack justifyContent="space-between" spacing={4}>
            <ProformaDevelopmentBudget proforma={proforma} />
            <SectionSummary
              title="Development budget description"
              category="Development Descriptions"
              dealId={dealId}
              externalToken={externalToken}
            />
          </Stack>
        </Stack>
      ) : (
        <NoProformaUploaded title="Development budget" />
      )}
    </>
  );
};

export default SectionDevelopmentBudget;
